module.exports = __webpack_public_path__ + "static/media/lp-about-box2.a21fd11d.png";